module.exports = __webpack_public_path__ + "img/intro-illustration@2x.5718c47b.png";